/**
 * Permission-related GraphQL queries
 */

export const GET_PERMISSIONS_QUERY = `
  query GetPermissions($role: user_roles_enum!, $companyId: Int!) {
    permissions(where: {role: {_eq: $role}, company_id: {_eq: $companyId}}) {
      id
      role
      screen
      company_id
      can_create
      can_edit
      can_view
      can_delete
      can_download
    }
  }
`;

export const GET_ALL_PERMISSIONS_QUERY = `
  query GetAllPermissions($where: permissions_bool_exp) {
    permissions(where: $where) {
      id
      role
      screen
      company_id
      can_create
      can_edit
      can_view
      can_delete
      can_download
    }
  }
`;

 